import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
    classGroups: {
        animate: [{ animate: ['slide', 'gradient-bg', 'gradient-text'] }],
    },
})
